module.exports = __webpack_public_path__ + "img/logo.7ca03987.svg";